<template>
  <material-card
    style="margin-top:20px"
    :title="$t('views.plangeneralparameters.flags')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="flag"
  >
    <v-dialog scrollable v-model="dialogs.edit" persistent max-width="500px">
      <material-card
        :title="$t(flagFormTitle)"
        :icon="flagFormIcon"
        :color="formColor"
      >
        <v-card-text>
          <flag-form
            @valid-changed="valid = $event"
            :item="flag"
            ref="flagForm"
            :dialog="dialogs.edit"
          ></flag-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="closeFlag">{{ $t("globals.cancel") }}</v-btn>
          <v-btn :disabled="!valid" color="primary" @click="saveFlag">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog v-model="dialogs.delete" scrollable persistent max-width="400">
      <material-card
        :title="$t('views.plangeneralparameters.remove_flag')"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.delete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" @click="removeFlag">
            {{ $t("globals.remove") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      :rowActions="rowActions"
      :floatActions="floatActions"
      fileNamePrefix="flags"
      identifier="table"
      @error="error = $event"
    ></pbas-data-table>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapGetters } from "vuex";
import { InMemoryProvider } from "pbas-vue-components";
import FlagsHeaders from "@/headers/BuilderFlags";
import ErrorHandler from "@/components/ErrorHandler";
import FlagForm from "@/components/FlagForm";
export default {
  components: { ErrorHandler, FlagForm },
  props: ["flags", "planIdentityId", "disabled"],
  data() {
    return {
      error: null,
      valid: false,
      dialogs: {
        edit: false,
        delete: false,
      },
      provider: undefined,
      isNew: false,
      floatActions: [
        {
          name: "addFlag",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.flag = {
              PlanIdentityId: this.planIdentityId,
              Color: "#FF0000",
              Identifier: Math.random(),
            };
            this.isNew = true;
            this.dialogs.edit = true;
            this.$nextTick(() => {
              this.$refs.flagForm.resetValidation();
            });
          },
          visible: () => !this.disabled,
        },
      ],
      rowActions: [
        {
          name: "editFlag",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.flag = JSON.parse(JSON.stringify(item));
            this.isNew = false;
            this.dialogs.edit = true;
            this.$nextTick(() => {
              this.$refs.flagForm.resetValidation();
            });
          },
          visible: () => !this.disabled,
        },
        {
          name: "removeFlag",
          icon: "delete",
          title: "globals.remove",
          handler: (item) => {
            this.flag = JSON.parse(JSON.stringify(item));
            this.dialogs.delete = true;
          },
          visible: () => !this.disabled,
        },
      ],
      headers: FlagsHeaders,
      flag: null,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    flagFormTitle() {
      return this.isNew
        ? "views.plangeneralparameters.create_new_flag"
        : "views.plangeneralparameters.edit_flag";
    },
    flagFormIcon() {
      return this.isNew ? "add" : "edit";
    },
    formColor() {
      return this.isNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
  },
  watch: {
    flags: {
      handler(v) {
        if (this.provider !== null && this.provider !== undefined) {
          this.provider.items = v;
          this.$refs.table.getDataAsync();
        } else {
          this.provider = new InMemoryProvider(v, this.headers);
        }
      },
    },
  },
  mounted() {
    if (this.flags !== null && this.flags !== undefined) {
      this.provider = new InMemoryProvider(this.flags, this.headers);
    }
  },
  methods: {
    saveFlag() {
      this.flag.Name = this.flag.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Name;
      if (this.flag.Color.hex) this.flag.Color = this.flag.Color.hex;
      if (this.isNew) {
        this.addFlag();
      } else {
        this.updateFlag();
      }
    },
    updateFlag() {
      let flag;
      flag = this.provider.items.filter(
        (o) => o.Identifier === this.flag.Identifier
      )[0];
      this.provider.items[this.provider.items.indexOf(flag)] = this.flag;

      this.closeFlag();
      this.$refs.table.getDataAsync();
      this.$emit("update-flags", this.provider.items);
    },
    addFlag() {
      this.provider.items.push(this.flag);
      this.closeFlag();
      this.$refs.table.getDataAsync();
      this.$emit("update-flags", this.provider.items);
    },
    removeFlag() {
      let flag;
      flag = this.provider.items.filter(
        (o) => o.Identifier === this.flag.Identifier
      )[0];

      this.provider.items.splice(this.provider.items.indexOf(flag), 1);
      this.closeFlag();
      this.$refs.table.getDataAsync();
      this.$emit("update-flags", this.provider.items);
    },

    closeFlag() {
      this.flag = null;
      // this.$refs.flagForm.resetValidation();
      this.dialogs.edit = false;
      this.dialogs.delete = false;
    },
  },
};
</script>

<style></style>
